/* Peakspan Oxy v1 — vanilla JS. Page content works without JS;
   this only adds header state, mobile nav, carousels, tabs, PDP gallery. */
(function () {
  'use strict';

  /* ---------- header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header && !header.classList.contains('site-header--solid')) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile nav ---------- */
  var navToggle = document.querySelector('.nav-toggle');
  if (navToggle && header) {
    navToggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    header.querySelectorAll('.mobile-panel a').forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('nav-open');
      });
    });
  }

  /* ---------- carousels (scroll-by-card) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('.car-track');
    if (!track) return;
    var step = function () {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    var bind = function (btn, dir) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        track.scrollBy({ left: dir * step() * 2, behavior: 'smooth' });
      });
    };
    bind(root.querySelector('[data-car-prev]'), -1);
    bind(root.querySelector('[data-car-next]'), 1);
  });

  /* ---------- tabs (science section) ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var pills = root.querySelectorAll('[data-tab]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var name = pill.getAttribute('data-tab');
        pills.forEach(function (p) { p.classList.toggle('active', p === pill); });
        root.querySelectorAll('[data-panel]').forEach(function (panel) {
          panel.classList.toggle('is-hidden', panel.getAttribute('data-panel') !== name);
        });
      });
    });
  });

  /* ---------- PDP gallery ---------- */
  var pdpMain = document.querySelector('[data-pdp-main] img');
  if (pdpMain) {
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var count = document.querySelector('[data-pdp-count]');
    var idx = 0;
    var show = function (i) {
      idx = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, n) { t.classList.toggle('active', n === idx); });
      var img = thumbs[idx].querySelector('img');
      if (img) { pdpMain.src = img.src; pdpMain.alt = img.alt; }
      if (count) count.textContent = (idx + 1) + ' / ' + thumbs.length;
    };
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = document.querySelector('[data-pdp-prev]');
    var next = document.querySelector('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  }

  /* ---------- PDP enquiry option toggles ATC label ---------- */
  var optInputs = document.querySelectorAll('.pdp-opt input[name="purchase_mode"]');
  var atcBtn = document.querySelector('[data-atc-label]');
  if (optInputs.length && atcBtn) {
    var selectedMode = function () {
      var selected = document.querySelector('.pdp-opt input[name="purchase_mode"]:checked');
      return selected ? selected.value : 'buy';
    };
    var updateAtcLabel = function () {
      atcBtn.textContent = selectedMode() === 'enquiry' ? 'Enquire now' : (atcBtn.getAttribute('data-atc-label') || 'Add to cart');
    };
    optInputs.forEach(function (input) {
      input.addEventListener('change', updateAtcLabel);
    });
    updateAtcLabel();
    var atcForm = atcBtn.closest('form');
    if (atcForm) {
      atcForm.addEventListener('submit', function (event) {
        if (selectedMode() !== 'enquiry') return;
        event.preventDefault();
        var enquiryUrl = atcBtn.getAttribute('data-enquiry-url') || '/pages/contact';
        window.location.assign(enquiryUrl + '?product=' + encodeURIComponent(window.location.pathname));
      });
    }
  }

  /* ---------- cart quantity steppers ---------- */
  document.querySelectorAll('.cart-qty').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var dec = wrap.querySelector('[data-qty-dec]');
    var inc = wrap.querySelector('[data-qty-inc]');
    if (!input) return;
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1); });
    if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; });
  });

  var openDialog = function (dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  var closeDialog = function (dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  var storageRead = function (key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  };

  var storageWrite = function (key, value) {
    try { window.localStorage.setItem(key, value); } catch (error) { return; }
  };

  var mailingDialog = document.querySelector('[data-mailing-popup]');
  if (mailingDialog) {
    var mailingStorageKey = 'peakspan_mailing_popup_dismissed_v1';
    var mailingDismissedAt = parseInt(storageRead(mailingStorageKey), 10) || 0;
    var mailingDismissalAge = Date.now() - mailingDismissedAt;
    var mailingShouldOpen = !mailingDismissedAt || mailingDismissalAge > 2592000000;
    var mailingSubmitted = mailingDialog.querySelector('[data-mailing-success]');
    var mailingErrors = mailingDialog.querySelector('.errors');
    var dismissMailing = function () {
      storageWrite(mailingStorageKey, String(Date.now()));
      closeDialog(mailingDialog);
    };
    mailingDialog.querySelectorAll('[data-mailing-dismiss]').forEach(function (button) {
      button.addEventListener('click', dismissMailing);
    });
    mailingDialog.addEventListener('cancel', function () {
      storageWrite(mailingStorageKey, String(Date.now()));
    });
    mailingDialog.addEventListener('click', function (event) {
      if (event.target === mailingDialog) dismissMailing();
    });
    if (mailingSubmitted || mailingErrors) openDialog(mailingDialog);
    else if (mailingShouldOpen) window.setTimeout(function () { openDialog(mailingDialog); }, 1200);
  }

  var recentRoot = document.querySelector('[data-recently-viewed]');
  var recentList = document.querySelector('[data-recently-viewed-list]');
  if (recentRoot && recentList) {
    var recentStorageKey = 'peakspan_recently_viewed_v1';
    var recentItems = [];
    try {
      var storedRecentItems = JSON.parse(storageRead(recentStorageKey) || '[]');
      if (Array.isArray(storedRecentItems)) recentItems = storedRecentItems;
    } catch (error) {
      recentItems = [];
    }
    var currentProduct = null;
    var currentProductData = document.querySelector('[data-recent-product]');
    if (currentProductData) {
      try { currentProduct = JSON.parse(currentProductData.textContent); } catch (error) { currentProduct = null; }
    }
    recentItems = recentItems.filter(function (item) {
      return item && typeof item.handle === 'string' && typeof item.title === 'string' && typeof item.url === 'string';
    });
    if (currentProduct && currentProduct.handle) {
      recentItems = recentItems.filter(function (item) { return item.handle !== currentProduct.handle; });
      recentItems.unshift(currentProduct);
      recentItems = recentItems.slice(0, 6);
      storageWrite(recentStorageKey, JSON.stringify(recentItems));
    }
    var displayedRecentItems = recentItems.filter(function (item) {
      return !currentProduct || item.handle !== currentProduct.handle;
    }).slice(0, 4);
    var safeProductUrl = function (value) {
      try {
        var url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return '';
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return '';
      }
    };
    var safeImageUrl = function (value) {
      if (typeof value !== 'string') return '';
      try {
        var url = new URL(value, window.location.origin);
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : '';
      } catch (error) {
        return '';
      }
    };
    displayedRecentItems.forEach(function (item) {
      var productUrl = safeProductUrl(item.url);
      if (!productUrl) return;
      var card = document.createElement('article');
      var link = document.createElement('a');
      var imageUrl = safeImageUrl(item.image);
      var body = document.createElement('span');
      var title = document.createElement('span');
      var price = document.createElement('span');
      card.className = 'ps-recent__card';
      card.setAttribute('role', 'listitem');
      link.href = productUrl;
      link.className = 'ps-recent__link';
      if (imageUrl) {
        var image = document.createElement('img');
        image.src = imageUrl;
        image.alt = item.title;
        image.loading = 'lazy';
        image.width = 600;
        image.height = 450;
        link.appendChild(image);
      }
      body.className = 'ps-recent__body';
      title.className = 'ps-recent__title';
      title.textContent = item.title;
      price.className = 'ps-recent__price';
      price.textContent = typeof item.price === 'string' ? item.price : '';
      body.appendChild(title);
      if (price.textContent) body.appendChild(price);
      link.appendChild(body);
      card.appendChild(link);
      recentList.appendChild(card);
    });
    if (recentList.children.length) recentRoot.hidden = false;
  }

  var cartDialog = document.querySelector('[data-cart-confirmation]');
  var cartLive = document.querySelector('[data-cart-live]');
  var lastCartTrigger = null;
  if (cartDialog) {
    cartDialog.querySelectorAll('[data-cart-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeDialog(cartDialog); });
    });
    cartDialog.addEventListener('click', function (event) {
      if (event.target === cartDialog) closeDialog(cartDialog);
    });
    cartDialog.addEventListener('close', function () {
      if (lastCartTrigger) lastCartTrigger.focus();
    });
  }

  var updateCartCount = function (count) {
    document.querySelectorAll('.cart-count').forEach(function (counter) {
      counter.textContent = String(count);
      counter.setAttribute('aria-label', count + (count === 1 ? ' item in cart' : ' items in cart'));
    });
    document.querySelectorAll('[data-cart-drawer-count]').forEach(function (counter) {
      counter.textContent = String(count);
    });
  };

  var showCartConfirmation = function (item, cart, trigger) {
    var title = item.product_title || item.title || 'Item';
    var suffix = '';
    lastCartTrigger = trigger;
    if (cartDialog) {
      var message = cartDialog.querySelector('[data-cart-message]');
      if (message) {
        suffix = message.getAttribute('data-added-suffix') || '';
        message.textContent = title + ' ' + suffix;
      }
      openDialog(cartDialog);
    }
    if (cartLive) cartLive.textContent = title + ' ' + (suffix || 'was added to your cart.');
    updateCartCount(cart.item_count);
  };

  if (!document.body.classList.contains('commerce-hold')) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (event.defaultPrevented || form.getAttribute('data-cart-busy') === 'true') return;
        var purchaseMode = form.closest('.pdp-buybox') && document.querySelector('input[name="purchase_mode"]:checked');
        if (purchaseMode && purchaseMode.value === 'enquiry') return;
        event.preventDefault();
        var submitButton = event.submitter || form.querySelector('[type="submit"]');
        var originalLabel = submitButton ? submitButton.textContent : '';
        var addUrl = document.body.getAttribute('data-cart-add-url');
        var cartUrl = document.body.getAttribute('data-cart-url');
        if (!addUrl || !cartUrl) return;
        form.setAttribute('data-cart-busy', 'true');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          if (cartLive && cartLive.getAttribute('data-loading-label')) submitButton.textContent = cartLive.getAttribute('data-loading-label');
        }
        fetch(addUrl, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            if (!response.ok) throw new Error(payload.description || 'Cart request failed');
            return payload;
          });
        }).then(function (item) {
          return fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : null; })
            .catch(function () { return null; })
            .then(function (cart) {
              if (!cart) {
                var existingCount = parseInt((document.querySelector('.cart-count') || {}).textContent, 10) || 0;
                cart = { item_count: existingCount + (parseInt(item.quantity, 10) || 1) };
              }
              showCartConfirmation(item, cart, submitButton);
            });
        }).catch(function () {
          if (cartLive) cartLive.textContent = cartLive.getAttribute('data-error-label') || 'We could not confirm that item. Please try again.';
        }).finally(function () {
          form.removeAttribute('data-cart-busy');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.textContent = originalLabel;
          }
        });
      });
    });
  }
})();
